/**
 * Get primary and secondary edge preferences.
 */
import { Edge } from "./getPosition"
import { stringLiteralArray } from "@oui/system/utils"

export type Preference = typeof preferences[number]

const preferences = stringLiteralArray([
  "top-left",
  "top",
  "top-right",
  "right-top",
  "right",
  "right-bottom",
  "bottom-right",
  "bottom",
  "bottom-left",
  "left-bottom",
  "left",
  "left-top"
])

const getPreference = (preference: Preference) =>
  preference.split("-") as [Edge, Edge | undefined]

export { preferences }
export default getPreference
